import ProfileIcon from "assets/images/profile.svg";
import { Avatar } from "components/Mui";

const TeamAvatar = (props) => {
  const { profilePicture, sx } = props;
  return <Avatar src={profilePicture || ProfileIcon} sx={sx}/>;
};

export default TeamAvatar;
